<template>
    <div class="grid">
        <v-progress-linear color="warning" indeterminate rounded height="3"
            v-if="isLoading || disableSaveBtn"></v-progress-linear>
        <v-form ref="form" lazy-validation v-on:submit.prevent v-if="editedItem && !isLoading">
            <div class="grid-title">
                <h4>
                    {{
                        $t(
                            isAddNew
                                ? "_ACTIVITY.ROOM_CATEGORY_CREATE"
                                : "_ACTIVITY.ROOM_CATEGORY_UPDATE"
                        )
                    }} - {{ $t('CHAIN') }}
                </h4>
            </div>
            <div class="grid-body p-3 border-top-unset mb-4">
                <v-row>
                    <v-col sm="12" class="pb-0">
                        <v-tabs v-model="tab" class="pl-0">
                            <v-tab>{{ $t("DEFAULT") }}</v-tab>
                            <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
                            <v-tab>{{ $t("ENGLISH") }}</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <v-row>
                                    <v-col sm="12" class="pb-0">
                                        <label>{{ $t("_CATEGORY.NAME") }} *</label>
                                        <v-text-field v-model="editedItem.nameVi" counter maxlength="250"
                                            class="input-counter" :rules="ruleName" outlined dense
                                            v-on:keyup="updateRoomTitle(editedItem.nameVi)">
                                        </v-text-field>
                                    </v-col>
                                    <v-col sm="12" class="pb-0">
                                        <label>{{ $t("_CATEGORY.DESCRIPTION") }}</label>
                                        <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                                            class="input-counter" v-model="editedItem.descriptionVi" dense outlined
                                            v-on:keyup="updateRoomDescription(editedItem.descriptionVi)">
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row>
                                    <v-col sm="12" class="pb-0">
                                        <label>{{ $t("_CATEGORY.NAME") }} *</label>
                                        <v-text-field v-model="editedItem.i18ns.find((x) => x.lang == 'vi').name" counter
                                            maxlength="250" class="input-counter" :rules="ruleName" outlined dense>
                                        </v-text-field>
                                    </v-col>
                                    <v-col sm="12" class="pb-0">
                                        <label>{{ $t("_CATEGORY.DESCRIPTION") }}</label>
                                        <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                                            class="input-counter"
                                            v-model="editedItem.i18ns.find((x) => x.lang == 'vi').description" dense
                                            outlined>
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row>
                                    <v-col sm="12" class="pb-0">
                                        <label>{{ $t("_CATEGORY.NAME") }} *</label>
                                        <v-text-field v-model="editedItem.i18ns.find((x) => x.lang == 'en').name" counter
                                            maxlength="250" class="input-counter" :rules="ruleName" outlined dense>
                                        </v-text-field>
                                    </v-col>
                                    <v-col sm="12" class="pb-0">
                                        <label>{{ $t("_CATEGORY.DESCRIPTION") }}</label>
                                        <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                                            class="input-counter"
                                            v-model="editedItem.i18ns.find((x) => x.lang == 'en').description" dense
                                            outlined>
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>
                    <v-col sm="3" class="py-0">
                        <label>{{ $t("_CATEGORY.CODE") }} *</label>
                        <v-text-field v-model="editedItem.roomCategoryCode" :disabled="!isAddNew" :rules="ruleCode" outlined
                            counter maxlength="20" class="input-counter code" dense>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-divider />
                <label class="label-title">{{ $t("ASSIGN_ROOM_TO_CATEGORY") }}</label>
                <v-row>
                    <v-col sm="3">
                        <v-card style="min-height: 350px">
                            <v-card-title class="fs-14">{{ $t("UNASSIGN") }}</v-card-title>
                            <div class="pl-2 pr-2">
                                <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('ROOM_TYPE')"
                                    v-model="searchUnApplyRoom" @input="searchOnUnApplyRoom" outlined dense></v-text-field>
                            </div>
                            <v-list class="mt-2" flat subheader three-line>
                                <v-list-item-group v-model="unApplySettingRoom" multiple active-class="grey lighten-3"
                                    style="max-height: 230px; overflow: auto">
                                    <template v-for="(item, index) in searchedUnApplyRoom">
                                        <v-list-item :key="index">
                                            <template v-slot:default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :input-value="active"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item.name"
                                                        :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-card>
                        <p class="mb-0 mt-2">
                            {{ searchedUnApplyRoom.length }}/{{ unApplyRoom.length }}
                            {{ $t("ITEMS_SHOWING") }}
                        </p>
                    </v-col>
                    <v-col sm="1" class="d-flex align-center justify-content-center">
                        <div>
                            <v-btn class="d-block" @click="leftToRightRoom">
                                <v-icon>navigate_next</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="rightToLeftRoom">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="allLeftToRightRoom">
                                <v-icon>keyboard_double_arrow_right</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="allRightToLeftRoom">
                                <v-icon>keyboard_double_arrow_left</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="compareRoom">
                                <v-icon>compare_arrows</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col sm="3">
                        <v-card style="min-height: 350px">
                            <v-card-title class="fs-14">{{ $t("ASSIGN") }}</v-card-title>
                            <div class="pl-2 pr-2">
                                <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('ROOM_TYPE')"
                                    v-model="searchApplyRoom" @input="searchOnApplyRoom" outlined dense></v-text-field>
                            </div>
                            <v-list class="mt-2" flat subheader three-line>
                                <v-list-item-group v-model="applySettingRoom" multiple active-class="grey lighten-3"
                                    style="max-height: 230px; overflow: auto">
                                    <template v-for="(item, index) in searchedApplyRoom">
                                        <v-list-item>
                                            <template v-slot:default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :input-value="active"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item.name"
                                                        :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-card>
                        <p class="mb-0 mt-2">
                            {{ searchedApplyRoom.length }}/{{ applyRoom.length }}
                            {{ $t("ITEMS_SHOWING") }}
                        </p>
                    </v-col>
                </v-row>
                <v-divider />
                <label class="label-title">{{ $t("ASSIGN_HOTEL_TO_CATEGORY") }}</label>
                <v-row>
                    <v-col sm="3">
                        <v-card style="min-height: 350px">
                            <v-card-title class="fs-14">{{ $t("UNASSIGN") }}</v-card-title>
                            <div class="pl-2 pr-2">
                                <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('HOTEL_NAME')"
                                    v-model="searchUnApply" @input="searchOnUnApply" outlined dense></v-text-field>
                            </div>
                            <v-list class="mt-2" flat subheader three-line>
                                <v-list-item-group v-model="unApplySetting" multiple active-class="grey lighten-3"
                                    style="max-height: 230px; overflow: auto">
                                    <template v-for="(item, index) in searchedUnApply">
                                        <v-list-item :key="index">
                                            <template v-slot:default="{ active }">
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item.name"
                                                        :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-card>
                        <p class="mb-0 mt-2">
                            {{ searchedUnApply.length }}/{{ unApplyHotel.length }}
                            {{ $t("ITEMS_SHOWING") }}
                        </p>
                    </v-col>
                    <v-col sm="1" class="d-flex align-center justify-content-center">
                        <div>
                            <v-btn class="d-block" @click="leftToRight">
                                <v-icon>navigate_next</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="rightToLeft">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="allLeftToRight">
                                <v-icon>keyboard_double_arrow_right</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="allRightToLeft">
                                <v-icon>keyboard_double_arrow_left</v-icon>
                            </v-btn>
                            <v-btn class="d-block mt-3" @click="compare">
                                <v-icon>compare_arrows</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col sm="3">
                        <v-card style="min-height: 350px">
                            <v-card-title class="fs-14">{{ $t("ASSIGN") }}</v-card-title>
                            <div class="pl-2 pr-2">
                                <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('HOTEL_NAME')"
                                    v-model="searchApply" @input="searchOnApply" outlined dense></v-text-field>
                            </div>
                            <v-list class="mt-2" flat subheader three-line>
                                <v-list-item-group v-model="applySetting" multiple active-class="grey lighten-3"
                                    style="max-height: 230px; overflow: auto">
                                    <template v-for="(item, index) in searchedApply">
                                        <v-list-item>
                                            <template v-slot:default="{ active }">
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item.name"
                                                        :class="!active ? 'text-secondary' : ''"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-card>
                        <p class="mb-0 mt-2">
                            {{ searchedApply.length }}/{{ applyHotel.length }}
                            {{ $t("ITEMS_SHOWING") }}
                        </p>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="!isAddNew">
                        <v-checkbox v-model="editedItem.overwrite"
                            :label="$t('ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL')" class="mt-0"></v-checkbox>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn depressed class="mr-5" @click="back">
                            {{ $t("BACK") }}
                        </v-btn>
                        <v-btn color="primary" class="pr-10 pl-10" @click="confirmSave()" :disabled="disableSaveBtn">{{
                            $t("SAVE")
                        }}</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-form>
    </div>
</template>

<style lang="scss" scoped>
.subtitle {
    text-transform: uppercase;
    font-size: 15px;
}

.code input {
    text-transform: uppercase;
}

.invalid-text {
    color: red;
    margin-top: -15px;
    position: absolute;
}

.item-cancel-policy {
    border: 1px dashed #cdcdcd;
    padding: 10px;

    p {
        margin-bottom: 0;
    }
}

.item-payment-policy {
    border: 1px dashed #cdcdcd;
    padding: 10px;

    p {
        margin-bottom: 0;
    }
}

.current-cancellation {
    background: linear-gradient(0deg, rgba(0, 62, 148, 0.1), rgba(0, 62, 148, 0.1)), #ffffff;
    padding: 0 10px;
    margin-bottom: 10px;
    border-radius: 5px;

    p {
        margin-bottom: 0;
    }
}
</style>
<script>
import store from "@/plugins/store";
import { ChainCategoryService } from "@/_services/ChainManage/roomCategory.service.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { _alert, _formatCurrency } from "@/_helpers/function.js";
const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
    if (term) {
        return items.filter((item) => toLower(item.name).includes(toLower(term)));
    }

    return items;
};
export default {
    created() {
        this.getRoomByChain();
    },
    data() {
        return {
            panel: [0, 1],
            disableSaveBtn: false,
            isLoading: false,
            editedItem: null,
            tab: null,
            sysLang: this.$i18n.locale,
            lang: "vi",
            isAddNew: true,
            isEmptyDefaultTitle: false,
            hotelList: [],
            applyHotel: [],
            unApplyHotel: [],
            searchApply: null,
            searchedApply: [],
            searchedUnApply: [],
            applySetting: [],
            unApplySetting: [],

            roomList: [],
            applyRoom: [],
            unApplyRoom: [],
            searchApplyRoom: null,
            searchedApplyRoom: [],
            searchedUnApplyRoom: [],
            applySettingRoom: [],
            unApplySettingRoom: [],
        };
    },
    computed: {},
    watch: {
        tab(value) {
            this.lang = value ? "en" : "vi";
        },
        lang(value) {
            this.editorData = this.editedItem.i18ns.find((x) => x.lang == value).description;
        },
    },
    mounted() { },
    methods: {
        async initialize() {
            this.isLoading = true;
            let id = this.$route.params.id;
            if (id != 0) {
                this.isAddNew = false;
                await ChainCategoryService.getDetail(id).then((res) => {
                    this.editedItem = res.data;
                    this.editedItem.overwrite = false;
                    if (this.editedItem.hotels.length > 0) {
                        this.applyHotel = this.hotelList.filter((e) =>
                            this.editedItem.hotels.includes(e.id)
                        );
                        this.unApplyHotel = this.hotelList.filter(
                            (e) => !this.editedItem.hotels.includes(e.id)
                        );

                        this.searchedApply = this.hotelList.filter((e) =>
                            this.editedItem.hotels.includes(e.id)
                        );
                        this.searchedUnApply = this.hotelList.filter(
                            (e) => !this.editedItem.hotels.includes(e.id)
                        );
                    } else {
                        this.unApplyHotel = [...this.hotelList];
                        this.clearSearch();
                    }
                    if (this.editedItem.roomIds.length > 0) {
                        this.applyRoom = this.roomList.filter((e) =>
                            this.editedItem.roomIds.includes(e.id)
                            );
                        this.unApplyRoom = this.roomList.filter(
                            (e) => !this.editedItem.roomIds.includes(e.id)
                        );

                        this.searchedApplyRoom = this.roomList.filter((e) =>
                            this.editedItem.roomIds.includes(e.id)
                        );
                        this.searchedUnApplyRoom = this.roomList.filter(
                            (e) => !this.editedItem.roomIds.includes(e.id)
                        );
                    } else {
                    this.unApplyRoom = [...this.roomList];
                    this.clearSearchRoom();
                    }
                });
            } else {
                this.isAddNew = true;
                this.editedItem = {
                    nameVi: null,
                    descriptionVi: null,
                    i18ns: [
                        {
                            description: "",
                            lang: "vi",
                            name: "",
                        },
                        {
                            description: "",
                            lang: "en",
                            name: "",
                        },
                    ],
                    id: null,
                    hotels: [],
                    roomCategoryCode: null
                };
                this.unApplyHotel = [...this.hotelList];
                this.clearSearch();
                this.unApplyRoom = [...this.roomList];
                this.clearSearchRoom();
            }
            this.isLoading = false;
        },
        confirmSave() {
            let form_validate = this.$refs.form.validate();

            if (!form_validate) {
                store.commit("alert/display", {
                    message: this.$t("_VALIDATE.REQUIRED"),
                    error: true,
                    success: false,
                });
                this.$nextTick(() => {
                    const el = document.querySelector(".v-messages.error--text");
                    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
                });
                return false;
            }

            let updatedData = Object.assign({}, this.editedItem);
            updatedData.roomCategoryCode = updatedData.roomCategoryCode.toUpperCase();
            updatedData.hotels = this.applyHotel
                .map((item) => item.id);
            updatedData.roomIds = this.applyRoom
                .map((item) => item.id);
            if (!this.isAddNew) {
                ChainCategoryService.updateRoomCategory(updatedData).then((res) => {
                    _alert(res, this.$t(res.data));
                });
            } else {
                delete updatedData.id;
                ChainCategoryService.createRoomCategory(updatedData).then((res) => {
                    if (res.responseCode === 0) {
                        _alert(res, this.$t(res.data), false);
                        this.$router.push({
                            name: "chain-roomCategorys",
                        });
                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                });
            }
        },
        updateRoomTitle(value) {
            if (value.length > 0) {
                this.isEmptyDefaultTitle = false;
                for (let i = 0; i < this.editedItem.i18ns.length; i++) {
                    this.editedItem.i18ns[i].name = value;
                }
            } else {
                this.isEmptyDefaultTitle = true;
            }
        },
        updateRoomDescription(value) {
            for (let i = 0; i < this.editedItem.i18ns.length; i++) {
                this.editedItem.i18ns[i].description = value;
            }
        },
        async getRoomByChain() {
            let body = {};
            body.keyword = "";
            body.status = null;
            body.limit = 10000;
            body.offset = 0;
            body.orderBy = "active";
            body.asc = false;
            await chainService.getAllRooms(body).then((res) => {
                if (res.responseCode == 0) {
                    this.roomList = res.data.map(e => Object.assign({}, {
                        id: e.roomId,
                        name: e.i18ns.find(y => y.lang == this.defaultI18n).name
                    }));
                    this.getHotelByChain()
                }
            }).finally(() => (this.isLoading = false));
        },
        async getHotelByChain() {
            await chainService.getHotelByChain(this.defaultI18n).then((res) => {
                if (res.responseCode == 0) {
                    this.hotelList = res.data;
                    this.initialize()
                }
            }).finally(() => (this.isLoading = false));
        },
        clearSearch() {
            this.searchApply = null;
            this.searchUnApply = null;
            this.searchOnApply();
            this.searchOnUnApply();
        },
        searchOnApply() {
            this.searchedApply = searchByName(this.applyHotel, this.searchApply);
        },
        searchOnUnApply() {
            this.searchedUnApply = searchByName(this.unApplyHotel, this.searchUnApply);
        },
        leftToRight() {
            if (this.unApplySetting.length > 0) {
                this.unApplySetting.forEach((e) => {
                    this.applyHotel.push(this.searchedUnApply[e]);
                });
                this.unApplyHotel = this.hotelList.filter(
                    (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
                );
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },

        rightToLeft() {
            if (this.applySetting.length > 0) {
                this.applySetting.forEach((e) => {
                    this.unApplyHotel.push(this.searchedApply[e]);
                });
                this.applyHotel = this.hotelList.filter(
                    (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
                );
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },
        allLeftToRight() {
            if (this.searchedUnApply.length > 0) {
                this.searchedUnApply.forEach((e) => {
                    this.applyHotel.push(e);
                });
                this.unApplyHotel = this.hotelList.filter(
                    (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
                );
                this.searchedUnApply = [];
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },
        allRightToLeft() {
            if (this.searchedApply.length > 0) {
                this.searchedApply.forEach((e) => {
                    this.unApplyHotel.push(e);
                });
                this.applyHotel = this.hotelList.filter(
                    (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
                );
                this.searchedApply = [];
                this.applySetting = [];
                this.unApplySetting = [];
                this.clearSearch();
            }
        },
        compare() {
            const apply = Array.from(new Set(this.applyHotel.map(JSON.stringify))).map(
                JSON.parse
            );
            const unApply = Array.from(new Set(this.unApplyHotel.map(JSON.stringify))).map(
                JSON.parse
            );
            this.applyHotel = [...unApply];
            this.unApplyHotel = [...apply];
            this.applySetting = [];
            this.unApplySetting = [];
            this.clearSearch();
        },
        // 
        clearSearchRoom() {
            this.searchApplyRoom = null;
            this.searchUnApplyRoom = null;
            this.searchOnApplyRoom();
            this.searchOnUnApplyRoom();
        },
        searchOnApplyRoom() {
            this.searchedApplyRoom = searchByName(this.applyRoom, this.searchApplyRoom);
        },
        searchOnUnApplyRoom() {
            this.searchedUnApplyRoom = searchByName(this.unApplyRoom, this.searchUnApplyRoom);
        },
        leftToRightRoom() {
            if (this.unApplySettingRoom.length > 0) {
                this.unApplySettingRoom.forEach((e) => {
                    this.applyRoom.push(this.searchedUnApplyRoom[e]);
                });
                this.unApplyRoom = this.roomList.filter(
                    (e) => !this.applyRoom.map((e) => e.id).includes(e.id)
                );
                this.applySettingRoom = [];
                this.unApplySettingRoom = [];
                this.clearSearchRoom();
            }
        },

        rightToLeftRoom() {
            if (this.applySettingRoom.length > 0) {
                this.applySettingRoom.forEach((e) => {
                    this.unApplyRoom.push(this.searchedApplyRoom[e]);
                });
                this.applyRoom = this.roomList.filter(
                    (e) => !this.unApplyRoom.map((e) => e.id).includes(e.id)
                );
                this.applySettingRoom = [];
                this.unApplySettingRoom = [];
                this.clearSearchRoom();
            }
        },
        allLeftToRightRoom() {
            if (this.searchedUnApplyRoom.length > 0) {
                this.searchedUnApplyRoom.forEach((e) => {
                    this.applyRoom.push(e);
                });
                this.unApplyRoom = this.roomList.filter(
                    (e) => !this.applyRoom.map((e) => e.id).includes(e.id)
                );
                this.searchedUnApplyRoom = [];
                this.applySettingRoom = [];
                this.unApplySettingRoom = [];
                this.clearSearchRoom();
            }
        },
        allRightToLeftRoom() {
            if (this.searchedApplyRoom.length > 0) {
                this.searchedApplyRoom.forEach((e) => {
                    this.unApplyRoom.push(e);
                });
                this.applyRoom = this.roomList.filter(
                    (e) => !this.unApplyRoom.map((e) => e.id).includes(e.id)
                );
                this.searchedApplyRoom = [];
                this.applySettingRoom = [];
                this.unApplySettingRoom = [];
                this.clearSearchRoom();
            }
        },
        compareRoom() {
            const apply = Array.from(new Set(this.applyRoom.map(JSON.stringify))).map(
                JSON.parse
            );
            const unApply = Array.from(new Set(this.unApplyRoom.map(JSON.stringify))).map(
                JSON.parse
            );
            this.applyRoom = [...unApply];
            this.unApplyRoom = [...apply];
            this.applySettingRoom = [];
            this.unApplySettingRoom = [];
            this.clearSearchRoom();
        },
        back() {
            this.$router.push({ name: "chain-roomCategorys" });
        },
    },
};
</script>
